import React, { useContext } from 'react';

import { withStyles } from '@material-ui/core/styles';

import { AppContext } from '../../contexts/app-context';
import { canJobRead, goToRoutePage } from '../../utils/helper';
import { JobIcon } from '../../utils/icons';
import {
  IconButton, ListItemIcon, ListItemText, MenuItem, Tooltip
} from '../../utils/material-ui-core';

interface IJobLogButtonProps {
  jobPrefix: string;
  jobName: string;
  mode: number;
  handleGridMoreMenuClose: () => void
}

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.secondary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const JobLogButton = ({ jobPrefix, jobName, mode, handleGridMoreMenuClose }: IJobLogButtonProps) => {
  const { setJobPagePathName, userFunctionAccess } = useContext(AppContext);
  return (
    <>
      {
        canJobRead(jobPrefix, userFunctionAccess) ? (
          <>
            {mode === 0 ?
              <IconButton>
                <Tooltip arrow title={"Jobs & Logs"}>
                  <JobIcon color="secondary" onClick={() => {
                    setJobPagePathName(jobName);
                    goToRoutePage('jobs');
                  }} />
                </Tooltip>
              </IconButton>
              :
              <StyledMenuItem
                onClick={(e) => {
                  setJobPagePathName(jobName);
                  goToRoutePage('jobs');
                  handleGridMoreMenuClose();
                }}
              >
                <ListItemIcon>
                  <JobIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={"Jobs & Logs"} />
              </StyledMenuItem>
            }
          </>
        )
          : null
      }
    </>
  );
};


export default JobLogButton;
